import { jsxs as p, jsx as r } from "react/jsx-runtime";
import "../../../fields/FieldContainer/index.js";
import n from "../../../fields/Checkbox/index.js";
import "../../../fields/ContentEditable/index.js";
import "../../../fields/DateInput/index.js";
import "date-fns";
import "react";
import "react-i18next";
import "classnames";
import "../../../index-YV3Z4nmr.js";
import "reactjs-popup";
import "../../../components/ThemeContext/index.js";
import "../../../components/Button/index.js";
import "../../../components/Modal/index.js";
import "react-dropzone";
import "../../../components/Breadcrumbs/index.js";
import "react-hook-form";
import "sanitize-html";
import "i18next";
import "@dnd-kit/core";
import "@dnd-kit/sortable";
import "react-number-format";
import "immutability-helper";
import "../../../fields/Input/index.js";
import "../../../components/Tooltip/index.js";
import "react-dom";
import "../../../fields/InputTooltip/index.js";
import "../../../fields/PhoneInput/index.js";
import "../../../fields/SocialSelect/index.js";
import "../../../fields/Switcher/index.js";
import "../../../fields/Textarea/index.js";
const s = "forma-ui__fill-variation-answer__item", l = "forma-ui__fill-variation-answer__itemDescription", _ = "forma-ui__fill-variation-answer__itemCheckbox", h = "forma-ui__fill-variation-answer__checkboxIcon", o = {
  item: s,
  itemDescription: l,
  itemCheckbox: _,
  checkboxIcon: h
}, P = ({ id: t, name: m, description: i, selected: e, onSelect: a }) => /* @__PURE__ */ p("div", { className: o.item, children: [
  /* @__PURE__ */ r(
    n,
    {
      name: `variant_${t}`,
      label: m,
      containerClass: o.itemCheckbox,
      onChange: (c) => a(t, c.target.checked),
      checked: e,
      viewStyle: "square",
      iconClass: o.checkboxIcon
    }
  ),
  !!(i != null && i.length) && /* @__PURE__ */ r("div", { className: o.itemDescription, children: i })
] });
export {
  P as default
};
